export const displayOrDownloadMediaObjectCellStyle = {
  clickableCell: {
    cursor: "pointer",
  },
  link: {
    textDecoration: "none",
    color: "text.primary",
  },
};
